// Activities used by the admin "Create Lesson Plan" screen and the coach "Daily Lesson Plan" view.
import { BarChart3, Book, BookOpen, Clapperboard, Keyboard, Laptop, Lightbulb, Mic, Monitor, Music, Palette, Pencil, Piano } from "lucide-react";

export const TBD = "To Be Decided (Select from syllabus)";

export const COMPUTER_APPS = [
  { name: "GCompris (Next)", Icon: Monitor, color: "#16a34a" },
  // Proposed when the child's last GCompris game wasn't passed (admin Create Schedule).
  { name: "GCompris (Practice)", Icon: Monitor, color: "#16a34a" },
  { name: "Typing Master", Icon: Keyboard, color: "#1d4ed8" },
  { name: "Art Weaver", Icon: Palette, color: "#f59e0b" },
  { name: "Canva (Drawing)", Icon: Palette, color: "#8b5cf6" },
];

// Activities offered in the One-on-One column, grouped by the course they belong to.
// A group's label is also the category a child is counted under in the coach view.
export const ACTIVITIES = {
  "action-songs": { label: "Action Songs", Icon: Music, color: "#ec4899", items: ["Roly Poly (Poem)", "Twinkle Twinkle (Poem)", "Johny Johny (Poem)", "Head Shoulders Knees (Action Song)"] },
  vocal: { label: "Vocal Songs", Icon: Mic, color: "#ec4899", items: ["Vocal Warm-up", "Sa Re Ga Ma Practice"] },
  instrumental: { label: "Instrumental Songs", Icon: Piano, color: "#ec4899", items: ["Keyboard Basics", "Rhythm Practice"] },
  scenes: { label: "Scenes", Icon: Clapperboard, color: "#16a34a", items: [...[3, 4, 5, 6].flatMap((n) => [`Scene ${n} (Revision)`, `Scene ${n} (Practice)`, `Scene ${n} (Next)`]), "Scene 5 – Nand Baba Story", "Next Scene (After 6)"] },
  beginners: { label: "Beginners", Icon: Pencil, color: "#ec4899", items: ["ABCD Writing Practice", "Phonics Practice", "Word Building"] },
  intermediate: { label: "Intermediate", Icon: BarChart3, color: "#2563eb", items: ["Sentence Reading", "Story Retelling", "Grammar Practice"] },
  computer: { label: "Computer Apps", Icon: Laptop, color: "#1d4ed8", items: ["Mouse & Keyboard Basics", "Typing Practice"] },
  "life-skills": { label: "Life Skills", Icon: Lightbulb, color: "#eab308", items: ["Hygiene Habits", "Good Manners", "Road Safety"] },
  stories: { label: "Stories", Icon: BookOpen, color: "#f59e0b", items: ["Nand Baba ki Chimbari Raat (Story)", "Nand Balak ki Chimbari Raat (Story)", "The Thirsty Crow (Story)"] },
};

export const activityMeta = (value) => Object.values(ACTIVITIES).find((g) => g.items.includes(value)) || { Icon: Book, color: "#dc2626" };
export const appMeta = (value) => COMPUTER_APPS.find((a) => a.name === value) || COMPUTER_APPS[0];
export const TBD_CATEGORY = "To Be Decided";
export const OTHER_CATEGORY = "Other";

// Category of a One-on-One activity, always worked out from the catalogue so it can never go stale.
export const categoryOf = (activity) => {
  if (!activity || activity === TBD) return TBD_CATEGORY;
  return Object.values(ACTIVITIES).find((g) => g.items.includes(activity))?.label || OTHER_CATEGORY;
};

// Category for a saved plan row: the catalogue wins; the stored value is only used for activities
// that are no longer in the catalogue.
export const rowCategory = (row) => {
  const fromCatalogue = categoryOf(row?.oneOnOne);
  return fromCatalogue === OTHER_CATEGORY && row?.category ? row.category : fromCatalogue;
};

// Categories in catalogue order, then "To Be Decided", then anything else.
const CATEGORY_RANK = [...Object.values(ACTIVITIES).map((g) => g.label), TBD_CATEGORY];
export const sortCategories = (list) => [...list].sort((a, b) => {
  const ra = CATEGORY_RANK.indexOf(a);
  const rb = CATEGORY_RANK.indexOf(b);
  return (ra < 0 ? CATEGORY_RANK.length : ra) - (rb < 0 ? CATEGORY_RANK.length : rb) || a.localeCompare(b);
});

export const categoryMeta = (category) => Object.values(ACTIVITIES).find((g) => g.label === category) || (category === TBD_CATEGORY ? { Icon: Book, color: "#dc2626" } : { Icon: BookOpen, color: "#1d4ed8" });

